import { render } from "./ArrowNext.vue?vue&type=template&id=8c015722"
import script from "./ArrowNext.vue?vue&type=script&lang=js"
export * from "./ArrowNext.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__